import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Button from "../components/Button";
import { Link } from "react-router-dom";
import Logo from "../assets/images/logo_white.png";

const Header = ({ showFillIn = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen((prevState) => !prevState);
  };

  const signerData = useSelector((state) => state?.signature?.signerData);

  const signerIds = useMemo(() => {
    return signerData?.data?.document_type === 1
      ? [
          "name_of_practice_1",
          "signature_1",
          "admin_name_1",
          "title_1",
          "signature_2",
          "name_of_practice_3",
          "signature_3",
          "admin_name_3",
          "title_3",
          "submit",
        ]
      : signerData?.data?.status === 0
      ? [
          "practicename",
          "name_of_practice_1",
          "signature_1",
          "admin_name_1",
          "admin_title_1",
          "name_of_practice_2",
          "signature_2",
          "name_of_practice_3",
          "signature_3",
          "admin_name_3",
          "admin_title_3",
          "submit",
        ]
      : [
          "md_signature_1",
          "md_name_1",
          "md_title_1",
          "md_signature_3",
          "md_name_3",
          "md_title_3",
          "submit",
        ];
  }, [signerData]);

  const [currentIndex, setCurrentIndex] = useState(-1);
  const documentType = signerData?.data?.signLink?.document_type;

  const scrollToNext = () => {
    for (let index = currentIndex + 1; index < signerIds.length; index += 1) {
      const element = document.getElementById(signerIds[index]);
      if (element) {
        setCurrentIndex(index);
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        element.focus();
        return;
      }
    }
    setCurrentIndex(-1);
  };

  return (
    <header className="bg-black px-10 lg:py-2 text-white shadow-md">
      <div className="w-full px-0 py-1 flex items-center justify-between">
        <div className="md:flex justify-between w-full items-center">
          <Link to="https://qualiphy.me/" target="_blank">
            <div className="">
              <img src={Logo} alt="Logo" className="h-8 md:h-12 w-100" />
            </div>
          </Link>
          <div>
            <h1 className="text-lg md:text-xl font-semibold">
              Review and complete
            </h1>
          </div>
          <div className="w-32 hidden sm:block" />
        </div>
        {showFillIn && signerData?.data?.status !== 2 && documentType !== 4 && (
          <div className="block sm:hidden">
            <Button
              backgroundColor="rgb(207 201 255)"
              labelColor="black"
              className="h-10 w-24 px-2 border-0 text-nowrap border-white-600"
              label="Fill In"
              onClick={scrollToNext}
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
